module.exports = __webpack_public_path__ + "media/pages/assets/images/facebook-eb0f35e180ee3242de0e6de7f6cd1c0d.svg";